import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { services } from '../../data/mockData';

const Services = () => {
  return (
    <section id="services" className="relative py-24 md:py-32 bg-[#f8f7f4]">
      {/* Gradient blob continuation */}
      <div className="absolute top-0 right-0 w-[60%] h-[50%] opacity-40 pointer-events-none">
        <div
          className="w-full h-full"
          style={{
            background: `
              radial-gradient(ellipse 70% 50% at 80% 0%, rgba(180, 230, 255, 0.5) 0%, transparent 50%),
              radial-gradient(ellipse 50% 50% at 60% 30%, rgba(220, 180, 255, 0.4) 0%, transparent 50%)
            `,
            filter: 'blur(60px)'
          }}
        />
      </div>

      <div className="relative z-10 px-6 md:px-12 lg:px-24">
        {/* Section title */}
        <div className="mb-16 md:mb-24">
          <h2 className="text-[clamp(3rem,8vw,8rem)] font-light text-gray-300 leading-none tracking-tight">
            <span className="block">OUR</span>
            <span className="block ml-[10%]">SERVICES</span>
          </h2>
        </div>

        {/* Services grid */}
        <div className="bg-white rounded-[2rem] md:rounded-[3rem] p-8 md:p-12 lg:p-16 shadow-sm">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
            {services.map((service, index) => (
              <div
                key={service.id}
                className="group cursor-pointer"
              >
                <div className="mb-4">
                  <span className="text-xs text-gray-400 tracking-wider">{service.subtitle}</span>
                </div>
                <h3 className="text-2xl md:text-3xl font-medium text-black mb-4 group-hover:text-gray-600 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>
                <div className="flex flex-wrap gap-2 mb-6">
                  {service.features.map((feature, idx) => (
                    <span
                      key={idx}
                      className="text-xs px-3 py-1 bg-gray-100 rounded-full text-gray-600"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
                {(service.link === '/services/lead-generation' || service.link === '/services/web-development' || service.link === '/services/social-media' || service.link === '/services/digital-ads' || service.link === '/services/media-production' || service.link === '/services/seo' || service.link === '/services/ai-solutions' || service.link === '/services/ai-email-marketing') ? (
                  <Link
                    to={service.link}
                    className="inline-flex items-center gap-2 text-sm font-medium text-black group-hover:gap-3 transition-all duration-300"
                  >
                    Find out more <ArrowRight size={16} />
                  </Link>
                ) : (
                  <a
                    href={service.link}
                    className="inline-flex items-center gap-2 text-sm font-medium text-black group-hover:gap-3 transition-all duration-300"
                  >
                    Find out more <ArrowRight size={16} />
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
